<h1>{{ "marketing-settings.consent-renewal.title" | translate }}</h1>
<p
	[innerHTML]="
		'marketing-settings.consent-renewal.lead'
			| translate: { mobile: phoneNumber, email: data.subscriptions.email ?? '' }
	"
></p>

<form [formGroup]="form">
	<div class="toggle-item-group" formGroupName="consents">
		<mat-slide-toggle class="toggle-item" color="primary" labelPosition="before" formControlName="brandMarketing">
			<span
				class="toggle-item-content"
				[innerHTML]="'marketing-settings.consent-renewal.toggle.brand-consent' | translate"
			></span>
		</mat-slide-toggle>

		<mat-slide-toggle class="toggle-item" color="primary" labelPosition="before" formControlName="groupMarketing">
			<span
				class="toggle-item-content"
				[innerHTML]="'marketing-settings.consent-renewal.toggle.group-consent' | translate"
			></span>
		</mat-slide-toggle>
	</div>

	<mat-divider class="divider"></mat-divider>

	<h3>{{ "marketing-settings.consent-renewal.communication-channel.lead" | translate }}</h3>

	<div class="toggle-item-group" formGroupName="subscriptions">
		<mat-slide-toggle
			class="toggle-item"
			color="primary"
			labelPosition="before"
			formControlName="acceptEmailOffers"
		>
			<span
				class="toggle-item-content"
				[innerHTML]="'marketing-settings.consent-renewal.communication-channel.email' | translate"
			></span>
		</mat-slide-toggle>
		<mat-slide-toggle class="toggle-item" color="primary" labelPosition="before" formControlName="acceptSmsOffers">
			<span
				class="toggle-item-content"
				[innerHTML]="'marketing-settings.consent-renewal.communication-channel.sms' | translate"
			></span>
		</mat-slide-toggle>
		<mat-slide-toggle
			class="toggle-item"
			color="primary"
			labelPosition="before"
			formControlName="acceptTelesalesOffers"
		>
			<span
				class="toggle-item-content"
				[innerHTML]="'marketing-settings.consent-renewal.communication-channel.phone' | translate"
			></span>
		</mat-slide-toggle>
	</div>

	<div class="actions">
		<button
			class="action-button"
			mat-stroked-button
			color="primary"
			type="button"
			test-id="cancel-button"
			data-test-id="cancel-button"
			(click)="onCancel()"
		>
			{{ "marketing-settings.consent-renewal.button.cancel" | translate }}
		</button>
		<button
			class="action-button"
			mat-flat-button
			color="accent"
			type="button"
			test-id="confirm-button"
			data-test-id="confirm-button"
			(click)="onConfirm()"
		>
			{{ "marketing-settings.consent-renewal.button.confirm" | translate }}
		</button>
	</div>

	<p [innerHTML]="'marketing-settings.consent-renewal.privacy' | translate"></p>
</form>
